import * as Core from '@skylab-shared/core';
import { PurchaseKindModel } from '@skylab-shared/dataModel';

@Core.BO({ modelType: PurchaseKindModel })
export class PurchaseKindBO extends Core.BusinessObjectBase<PurchaseKindModel> {
    public constructor(
        weaver: Core.Weaver,
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.registerCoreFeatures();
    }

    //#region Core feature actions

    public registerCoreFeatures(): void {
        this.readonly.setAsReadonly<PurchaseKindModel>([PurchaseKindModel, 'name']);
    }

    //#endregion
}
